import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFSmartGenerator from '@/components/UI/svg/mm100/Icon/EFSmartGenerator';
import EFShorePower from '@/components/UI/svg/mm100/Icon/EFShorePower';
import EFAlternator from '@/components/UI/svg/mm100/Icon/EFAlternator';
import EFSolarPower from '@/components/UI/svg/mm100/Icon/EFSolarPower';
import EFVideoPlayer from '@/components/UI/svg/mm100/Icon/EFVideoPlayer';
import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';
import EFShorePowerAU from '@/components/UI/svg/mm100/Icon/EFShorePowerAU';
import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ type = 'offGrid', callBack }: any) {
    const { useLang, useEffect, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);
    const router = useRouter();
    const { locale } = router;
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/wwGcveNTQj8',
        jp: 'https://www.youtube.com/embed/iKYLTKkiFuo',
        cn: {
            SD: 'https://videos.ecoflow.com/6ca58e33e6854db7962947fbf1923f5d/bb08627bbeec449b885e6c41d308b4a1-4ad54e6b8124b7d9c219943feae68eed-fd.mp4',
            HD: 'https://videos.ecoflow.com/6ca58e33e6854db7962947fbf1923f5d/bb08627bbeec449b885e6c41d308b4a1-7e5be3916e3740938880b802ba814ffd-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/345a5e67-1841d8eec62-0004-9c91-e6d-40030.mp4',
        },
    };

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.kitE`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.kitE} kitE`}>
            {type === 'offGrid' ? (
                <div className="kit-inter-off-grid">
                    <div className="left-box">
                        <div className="kit-ms1">{t('presale.product.kitE_off_grid_ms1')}</div>
                        <div className="off-grid-box">
                            <div className="list-item">
                                <div className="list-img">
                                    <EFSolarPower width="38px" height="40px" />
                                </div>
                                <div className="list-ms1">4800W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box1_ms2')}</div>
                            </div>
                            <div className="list-item">
                                <div className="list-img">
                                    <EFSmartGenerator width="44px" height="34px" />
                                </div>
                                <div className="list-ms1">1800W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box2_ms2')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="kit-ms2">{t('presale.product.kitE_off_grid_ms2')}</div>
                        <div className="kit-ms3">{t('presale.product.kitE_ms3')}</div>
                        <div className="watch-video-btn watch-video-og" onClick={() => playerVideo(t('presale.product.kitE_off_grid_ms2'))}>
                            {t('presale.product.watch_video')}
                            <EFVideoPlayer className="icon" color="#2673ff" />
                        </div>
                        <div className="more-win-fun" onClick={() => callBack('cablePack')} style={{ display: locale === 'us' ? 'inline-block' : 'none' }}>
                            {t('presale.product.kitE_more_win_fun')}
                            <span className="more-win-fun-icon">
                                <EFProductWinAdd />
                            </span>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="kit-inter-rv">
                    <div className="left-box">
                        <div className="kit-ms1">{t('presale.product.kitE_rv_ms1')}</div>
                        <div className="rv-box">
                            <div className="list-item">
                                <div className="list-img">
                                    <EFSolarPower width="38px" height="40px" />
                                </div>
                                <div className="list-ms1">4800W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box1_ms2')}</div>
                            </div>
                            <div className="list-item">
                                <div className="list-img">
                                    <EFAlternator width="37px" height="37px" />
                                </div>
                                <div className="list-ms1">{locale !== 'cn' ? '1000W' : '1600W'}</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box4_ms2')}</div>
                            </div>
                            <div className="list-item">
                                <div className="list-img">
                                    {locale === 'au' ? <EFShorePowerAU width="35px" height="35px" /> : <EFShorePower width="35px" height="35px" />}
                                </div>
                                <div className="list-ms1">3000W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box3_ms2')}</div>
                            </div>
                            <div className="list-item">
                                <div className="list-img">
                                    <EFSmartGenerator width="44px" height="34px" />
                                </div>
                                <div className="list-ms1">1800W</div>
                                <div className="list-ms2">{t('presale.product.kitE_list_box2_ms2')}</div>
                            </div>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="kit-ms2">{t('presale.product.kitE_rv_ms2')}</div>
                        <div className="kit-ms3">{t('presale.product.kitE_ms3')}</div>
                        <div className="watch-video-btn" onClick={() => playerVideo(t('presale.product.kitE_rv_ms2'))}>
                            {t('presale.product.watch_video')}
                            <EFVideoPlayer className="icon" color="#2673ff" />
                        </div>
                        <div className="more-win-fun" onClick={() => callBack('cablePack')} style={{ display: locale === 'us' ? 'inline-block' : 'none' }}>
                            {t('presale.product.kitE_more_win_fun')}
                            <span className="more-win-fun-icon">
                                <EFProductWinAdd />
                            </span>
                        </div>
                    </div>
                </div>
            )}
            {type === 'rv' ? (
                <div className="video-box">
                    {videoEnterA && <EFVideo sources={['/video/mm100m/kitE_pc_rv_1.webm', '/video/mm100/kitE_pc_rv_1.mp4']} className="video" />}
                    <span className="text-top-left text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box1_ms2_cn' : 'presale.product.kitE_list_box1_ms2')}
                    </span>
                    <span className="text-top-right text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box4_ms2_cn' : 'presale.product.kitE_list_box4_ms2')}
                    </span>
                    <span className="text-bottom-left text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box3_ms2_cn' : 'presale.product.kitE_list_box3_ms2')}
                    </span>
                    <span className="text-bottom-right text">
                        {t(locale === 'cn' ? 'presale.product.kitE_list_box2_ms2_cn' : 'presale.product.kitE_list_box2_ms2')}
                    </span>
                </div>
            ) : (
                <div className="video-box offGrid-video">
                    {videoEnterA && <EFVideo sources={['/video/mm100m/kitE_pc_offGrid_1.webm', '/video/mm100/kitE_pc_offGrid_1.mp4']} className="video" />}
                    <span className="text-bottom-left text">{t('presale.product.kitE_list_box1_ms2')}</span>
                    <span className="text-bottom-right text">{t('presale.product.kitE_list_box2_ms2')}</span>
                </div>
            )}
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
